import { TableRow, TableCell } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import React from 'react';

interface IProps {
  columns: number;
  rows: number;
  rowHeight?: number;
  animation?: 'pulse' | 'wave' | false;
  isOriginalDefaultComponent?: boolean;
}

const TableSkeleton = (props: IProps): JSX.Element => {
  const { columns, rows, animation = 'pulse', rowHeight = 52, isOriginalDefaultComponent = false } = props;

  return (
    <React.Fragment>
      {Array.from({ length: rows }, (_, r) => (
        <TableRow key={`table-skeleton-row-${r}`} style={{ height: rowHeight }} {...(isOriginalDefaultComponent ? { component: 'tr' } : {})}>
          {Array.from({ length: columns }, (_, c) => (
            <TableCell key={`table-skeleton-column-${c}`} {...(isOriginalDefaultComponent ? { component: 'td' } : {})}>
              <Skeleton animation={animation} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </React.Fragment>
  );
};

export default TableSkeleton;
